import $ from 'jquery';

import ModalFactory from 'chairisher/factory/modal';

import { isTosappAgreementRequired } from 'chairisher/context/auth';
import { logAmplitudeEvent } from 'chairisher/util/analytics';

export default class TermsOfServiceAndPrivacyPolicyView {
    constructor() {
        this.bannerFormContainerSelector = '#js-tosapp-banner-form-container';
        this.modalId = 'js-tosapp-modal';
    }

    /**
     * Shows the banner
     */
    showBanner() {
        if (isTosappAgreementRequired()) {
            const $formContainer = $(this.bannerFormContainerSelector);
            const $form = $formContainer.find('form');
            const $agreeButton = $form.find('.js-tosapp-agree');

            $form.on('submit', (e) => {
                e.preventDefault();
                $agreeButton.prop('disabled', true);

                $.ajax({
                    data: $form.serialize(),
                    method: 'POST',
                    url: $form.attr('action'),
                })
                    .done(() => {
                        $formContainer.addClass('hidden');
                        logAmplitudeEvent('tosapp - agree');
                    })
                    .fail(() => {
                        $agreeButton.prop('disabled', false);
                    });
            });

            $formContainer.removeClass('hidden');
        }
    }

    /**
     * Shows the modal
     *
     * @param {boolean} shouldCancelRedirect Whether clicking cancel should redirect to the root page
     */
    showModal(shouldCancelRedirect) {
        const $deferred = $.Deferred();
        if (isTosappAgreementRequired()) {
            const $modal = ModalFactory.createModal(this.modalId);
            const $modalContent = $('#js-tosapp-modal-template');
            $modal.find('.modal-body').html($modalContent.html());
            $modal.find('.js-modal-header').remove();

            $modal.appendTo(document.body);

            // assign this button after setting the modal body above
            const $agreeButton = $modal.find('.js-tosapp-agree');

            $modal.on('submit', 'form', (e) => {
                e.preventDefault();
                $agreeButton.prop('disabled', true);

                const $form = $modal.find('form');
                $.ajax({
                    data: $form.serialize(),
                    method: 'POST',
                    url: $form.attr('action'),
                })
                    .done(() => {
                        $modal.modal('hide');
                        logAmplitudeEvent('tosapp - agree');

                        $(this.bannerFormContainerSelector).addClass('hidden');

                        $deferred.resolve();
                    })
                    .fail(() => {
                        $agreeButton.prop('disabled', false);
                    });
            });

            $modal.on('click', '.js-tosapp-cancel', (e) => {
                e.preventDefault();
                $modal.modal('hide');
                logAmplitudeEvent('tosapp - disagree');

                if (shouldCancelRedirect) {
                    window.location.href = '/';
                }
                $deferred.resolve();
            });

            $modal.on('hidden.bs.modal', () => {
                $modal.remove();
            });

            $modal.on('shown.bs.modal', () => {
                logAmplitudeEvent('screen - agree tosapp');
            });

            $modal.modal({
                backdrop: 'static',
                keyboard: false,
                show: true,
            });
        } else {
            $deferred.resolve();
        }

        return $deferred;
    }
}
